export const COVERAGE_AVAILABLE = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'reverification',
    label: 'Case Type',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'insurance_type',
    label: 'Insurance Type',
  },
  {
    value: 'physician',
    label: 'Physician',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
    width: 10
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
    width: 10
  },
  {
    value: '',
    label: 'Provide Patient Status',
    width: 20
  },
  {
    value:'',
    label:'Rerun',
    width: 5
  },
  {
    value: '',
    label: 'FAM/Office Note',
    width: 4
  },
];
export const COVERAGE_MANUFACTURE_AVAILABLE = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'reverification',
    label: 'Case type',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: 'physician',
    label: 'Physician',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
    width: 10
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
    width: 10
  },
  {
    value: '',
    label: 'Provide Treatment Status',
    width: 20
  },
  {
    value: '',
    label: 'PCC eligible',
    width: 4
  },

  {
    value: '',
    label: 'QNS eligible',
    width: 4
  },
  {
    value: '',
    label: 'Patient Activation Status',
    width: 4
  },
  {
    value: 'indication',
    label: 'Indication',
    width: 4
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: '',
    label: 'FAM/Office Note',
    width: 4
  },
  
 
];
export const ACTION_REQUIRED = [
  {
    value: 'patient_name',
    label: 'Patient Name',
    
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
   
    
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
    
  },
  {
    value: 'reverification',
    label: 'Case Type',
    
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
    
  },
  {
    value: 'insurance_type',
    label: 'Insurance Type',
    
  },
  {
    value: 'physician',
    label: 'Physician',
    
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
    width: 10
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
    width: 10
  },
  {
    value: '',
    label: 'Next Steps',
    width: 20
  },
  {
    value:"",
    label:'Rerun',
    width: 5
  
  },
  {
    value: '',
    label: 'FAM/Office Note',
    width: 4
  }

]
export const ACTION_MANUFACTURE_REQUIRED = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'reverification',
    label: 'Case type',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: 'physician',
    label: 'Physician',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
     width:10
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
     width:10
  },
  {
    value: '',
    label: 'Next Steps',
     width:20
  },
  {
    value: '',
    label: 'PCC eligible',
     width:4
  },

  {
    value: '',
    label: 'QNS eligible',
     width:4
  },
  {
    value: '',
    label: 'Patient Activation Status',
     width:4
  },
  {
    value: 'indication',
    label: 'Indication',
     width:4
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: '',
    label: 'FAM/Office Note',
     width:4
  },
  
]

export const SPECIALITY_PHARMACY = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: 'sp_transfered_to',
    label: 'SP Transferred to',
  },
  {
    value: 'date_transferred',
    label: 'Date Transferred',
  },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: 'date_shipped',
    label: 'Date Shipped',
  },
  {
    value: 'carrier',
    label: 'Carrier',
  },
  {
    value: 'tracking_number',
    label: 'Tracking Number',
  },
  {
    value: '',
    label: 'Pharmacy (SP) Status',
    width:10
  },
  {
    value: '',
    label: 'Provide Treatment Status',
    width:20
  },
  {
    value:"",
    label:'Rerun',
    width:5
  },
  {
    value: '',
    label: 'FAM/Office Note',
    width: 4
  }
]

export const SPECIALITY_MANUFACTURE_PHARMACY = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  
  {
    value: 'sp_transferred_to',
    label: 'SP Transferred To',
  },
  {
    value: 'date_transferred',
    label: 'Date Transferred',
  },
  {
    value: '',
    label: 'Status Update',
  },
  {
    value: 'date_shipped',
    label: 'Date Shipped',
  },
  {
    value: 'carrier',
    label: 'Carrier',
  },
  {
    value: 'tracking_number',
    label: 'Tracking Number',
  },
  {
    value: '',
    label: 'Pharmacy (SP) Status',
    width:10
  },
  {
    value: '',
    label: 'Provide Treatment Status',
     width:25
  },
  {
    value: '',
    label: 'PCC eligible',
     width:4
  },

  {
    value: '',
    label: 'QNS eligible',
     width:4
  },
   {
    value: '',
    label: 'Patient Activation Status',
     width:4
  },
  {
    value: 'indication',
    label: 'Indication',
     width:4
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: '',
    label: 'FAM/Office Note',
     width:4
  },
]

export const PENDING_TABLE = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'reverification',
    label: 'Case Type',
  },
  {
    value: 'bi_submitted',
    label: 'BI Submitted',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'insurance_type',
    label: 'Primary Insurance Type',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
    width: 10
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
    width: 10
  },
  {
    value: '',
    label: 'Provide Patient Status',
    width: 20
  },
  {
    value:"",
    label:'Rerun',
    width: 5
  },
  {
    value: '',
    label: 'FAM/Office Note',
    width: 4
  }
];

export const PENDING_MANUFACTURE_TABLE = [
  {
    value: 'patient_name',
    label: 'Patient Name',
  },
  {
    value: 'patient_id',
    label: 'Patient ID',
  },
  {
    value: 'bi_case_id',
    label: 'BI Case ID',
  },
  {
    value: 'case_type',
    label: 'Case Type	',
  },
  {
    value: 'bi_submitted',
    label: 'BI Submitted',
  },
  {
    value: 'bi_completed',
    label: 'BI Completed',
  },
  {
    value: 'payer',
    label: 'Payer',
  },
  {
    value: 'provider',
    label: 'Provider',
  },
  {
    value: '',
    label: 'MEDICAL COVERAGE (BUY & BILL)',
     width:10
  },
  {
    value: '',
    label: ' PHARMACY COVERAGE (SPECIALTY PHARMACY)',
     width:10
  },
  {
    value: '',
    label: 'Provide Treatment Status',
     width:25
  },
  {
    value: '',
    label: 'PCC eligible',
     width:4
  },

  {
    value: '',
    label: 'QNS eligible',
     width:4
  },
  //  {
  //   value: '',
  //   label: 'Patient Activation Status',
  // },
  {
    value: 'indication',
    label: 'Indication',
     width:4
  },
  // {
  //   value: '',
  //   label: 'Confirm Indiction',
  // },
  {
    value: '',
    label: 'FAM/Office Note',
     width:4
  },
];
